import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelPaymentsEditResolverErrorStatesEnum {
    GetPaymentFailed = ErrorStateScheduleEnum.PanelPaymentsEditResolverStatesStartIndex,
    PaymentNotFound,
    GetPaymentStatusTriggersFailed,
    GetCountriesFailed,
    GetCountriesInvalidData
}
